import { path } from './index';
import { ISidebar } from '../components/SideBar/Sidebar.type';
import {
  KalpProductSVG,
  KalpWalletSVG,
  PersonalInfoSVG,
  SettingSVG,
  SubscriptionSVG,
  TransactionSVG
} from '../assets/svg';
import CreditSVG from '../assets/svg/CreditSVG';

const sideBarPathList: string[] = [
  path.PERSONAL_INFO,
  path.KALP_PRODUCTS,
  path.SUBSCRIPTION,
  path.CREDIT,
  path.TRANSACTION,
  path.SETTINGS,
];
console.log(localStorage.getItem('access_token'))
console.log(localStorage.getItem('refresh_token'))

const list: ISidebar[] = [
  {
    name: 'Personal Info',
    path: path.PERSONAL_INFO,
    icon: PersonalInfoSVG,
    hasChild: false,
  },
  {
    name: 'Applications',
    path: path.KALP_PRODUCTS,
    icon: KalpProductSVG,
    hasChild: false,
  },
  // {
  //   name: 'Subscription',
  //   path: path.SUBSCRIPTION,
  //   icon: SubscriptionSVG,
  //   hasChild: false,
  // },
  // {
  //   name: 'Credit',
  //   path: path.CREDIT,
  //   icon: KalpWalletSVG,
  //   hasChild: false,
  // },
  // {
  //   name: 'Transactions',
  //   path: path.TRANSACTION,
  //   icon: TransactionSVG,
  //   hasChild: false,
  // },
   {
    name: 'Credits',
    path:'',
    icon: CreditSVG,
    hasChild: false,
    newTab:true
  },
  {
    name: 'Settings',
    path: path.SETTINGS,
    icon: SettingSVG,
    hasChild: false,
  }
];

const sidebar = { list, sideBarPathList };

export default sidebar;
